import { DetailStep } from '@/pages/onboarding/DetailStep';
import { ProfessionStep } from '@/pages/onboarding/ProfessionStep';
import { SummaryStep } from '@/pages/onboarding/SummaryStep';
import { WorkStep } from '@/pages/onboarding/WorkStep';
import type { OnboardingStepBodyProps } from '@/pages/onboarding/onboarding.types';

export const OnboardingStepBody = ({
  step,
  copy,
  control,
  values,
  onEditStep,
  isEditMode,
  onSignatureEdit,
}: OnboardingStepBodyProps) => {
  switch (step) {
    case 1:
      return <ProfessionStep copy={copy} control={control} />;
    case 2:
      return <WorkStep copy={copy} control={control} />;
    case 3:
      return <DetailStep copy={copy} control={control} />;
    default:
      return (
        <SummaryStep
          copy={copy}
          control={control}
          values={values}
          onEditStep={onEditStep}
          isEditMode={isEditMode}
          onSignatureEdit={onSignatureEdit}
        />
      );
  }
};
